module.exports = __webpack_public_path__ + "img/martinmartinez.7f4f96f1.jpg";